import { request } from '@/api/client';

export interface TagInfo {
  name: string;
  count: number;
  companies: string[];
}

export interface TagStats {
  businessTotal: number;
  sourceTotal: number;
  companyTotal: number;
  totalUsages: number;
}

export function fetchBusinessTags(): Promise<TagInfo[]> {
  return request<TagInfo[]>('/tags/business');
}

export function createBusinessTag(name: string): Promise<TagInfo> {
  return request<TagInfo>('/tags/business', { method: 'POST', body: { name } });
}

export function updateBusinessTag(oldName: string, newName: string): Promise<TagInfo> {
  return request<TagInfo>(`/tags/business/${encodeURIComponent(oldName)}`, { method: 'PUT', body: { name: newName } });
}

export function deleteBusinessTag(name: string): Promise<void> {
  return request<void>(`/tags/business/${encodeURIComponent(name)}`, { method: 'DELETE' });
}

export function fetchSourceTags(): Promise<TagInfo[]> {
  return request<TagInfo[]>('/tags/source');
}

export function createSourceTag(name: string): Promise<TagInfo> {
  return request<TagInfo>('/tags/source', { method: 'POST', body: { name } });
}

export function updateSourceTag(oldName: string, newName: string): Promise<TagInfo> {
  return request<TagInfo>(`/tags/source/${encodeURIComponent(oldName)}`, { method: 'PUT', body: { name: newName } });
}

export function deleteSourceTag(name: string): Promise<void> {
  return request<void>(`/tags/source/${encodeURIComponent(name)}`, { method: 'DELETE' });
}

export function fetchTagStats(): Promise<TagStats> {
  return request<TagStats>('/tags/stats');
}

export function fetchTagColors(): Promise<Record<string, string>> {
  return request<Record<string, string>>('/tags/colors');
}

export function setTagColor(tag: string, color: string): Promise<void> {
  return request<void>('/tags/colors', { method: 'PUT', body: { tag, color } });
}

export function deleteTagColor(tag: string): Promise<void> {
  return request<void>(`/tags/colors/${encodeURIComponent(tag)}`, { method: 'DELETE' });
}